import { render, staticRenderFns } from "./project.detail.vue?vue&type=template&id=47274b16&scoped=true&"
import script from "./project.detail.vue?vue&type=script&lang=js&"
export * from "./project.detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47274b16",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\public\\Isaura\\id.es6.vn\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('47274b16')) {
      api.createRecord('47274b16', component.options)
    } else {
      api.reload('47274b16', component.options)
    }
    module.hot.accept("./project.detail.vue?vue&type=template&id=47274b16&scoped=true&", function () {
      api.rerender('47274b16', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/project/project.detail.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/views/project/project.detail.vue
// module id = 709
// module chunks = 8